/**
 * A paleta de comandos: Ctrl+K vai a qualquer tela.
 *
 * ═══ PARA QUEM É ═══
 *
 * Para quem já usa o software todo dia. O trilho lateral resolve para
 * quem está aprendendo — ele mostra o que existe. Depois de decorado,
 * mirar um ícone de 16 px passa a ser o passo lento, e a paleta troca
 * isso por três teclas.
 *
 * Não substitui o menu, e por isso não some nada da tela: paleta é
 * atalho de quem sabe o nome, e menu é resposta para quem não sabe.
 */

import { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { useNavigate } from 'react-router-dom'
import { TELAS } from '../navegacao'
import { filtrar, andar, type ItemDaPaleta } from '../paleta'

const ITENS: ItemDaPaleta[] = TELAS.map(t => ({
  rota: t.rota, nome: t.nome, dica: t.subtitulo,
}))

export function Paleta() {
  const [aberta, setAberta] = useState(false)
  const [busca, setBusca] = useState('')
  const [escolhido, setEscolhido] = useState(0)
  const campo = useRef<HTMLInputElement>(null)
  const ir = useNavigate()

  const achados = filtrar(ITENS, busca)

  useEffect(() => {
    const tecla = (e: KeyboardEvent) => {
      // Ctrl+K e Cmd+K: o atalho que já é o de "buscar" em quase tudo.
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault()
        setAberta(a => !a)
        setBusca('')
        setEscolhido(0)
      }
    }
    document.addEventListener('keydown', tecla)
    return () => document.removeEventListener('keydown', tecla)
  }, [])

  useEffect(() => {
    if (aberta) campo.current?.focus()
  }, [aberta])

  if (!aberta) return null

  const fechar = () => setAberta(false)

  const navegar = (i: number) => {
    const alvo = achados[i]
    if (!alvo) return
    fechar()
    ir(alvo.rota)
  }

  return createPortal(
    <div className="paleta on" onClick={fechar}>
      <div className="paleta-caixa" onClick={e => e.stopPropagation()}>
        <input ref={campo} className="paleta-busca" value={busca}
               placeholder="Ir para… (Esc fecha)"
               onChange={e => { setBusca(e.target.value); setEscolhido(0) }}
               onKeyDown={e => {
                 if (e.key === 'Escape') return fechar()
                 if (e.key === 'Enter') return navegar(escolhido)
                 if (e.key === 'ArrowDown') {
                   e.preventDefault()
                   setEscolhido(n => andar(n, achados.length, 1))
                 }
                 if (e.key === 'ArrowUp') {
                   e.preventDefault()
                   setEscolhido(n => andar(n, achados.length, -1))
                 }
               }} />

        <div className="paleta-lista">
          {achados.length
            ? achados.map((i, n) => (
              <button key={i.rota}
                      className={'paleta-item' + (n === escolhido ? ' ativo' : '')}
                      onMouseEnter={() => setEscolhido(n)}
                      onClick={() => navegar(n)}>
                <span className="pi-nome">{i.nome}</span>
                <span className="pi-dica">{i.dica}</span>
              </button>
            ))
            : <div className="paleta-vazio">Nenhuma tela com esse nome</div>}
        </div>
      </div>
    </div>,
    document.body)
}
